import { encryptData, decryptData, deriveKeyFromPassword } from "../utils/CryptoHelpers";
import nacl from 'tweetnacl';
import { Keypair } from '@solana/web3.js';

export async function storeUnlinkKeys(userId, password, salt, keys, mnemonic) {
  const enc = async (label, val) => {

  	// Derive a symmetric encryption key using the password + salt via PBKDF2
  	const key = await deriveKeyFromPassword(password, salt);

    const encrypted = await encryptData(JSON.stringify(Array.from(val)), key);
    localStorage.setItem(`unlink_${userId}_${label}`, JSON.stringify(encrypted));
  };

  await enc("kyber_private", keys.kyberPrivateKey);
  await enc("kyber_public", keys.kyberPublicKey);
  await enc("view_private", keys.viewPrivateKey);
  await enc("view_public", keys.viewPublicKey);
  await enc("funding_private", keys.fundingPrivateKey);
  await enc("funding_public", keys.fundingPublicKey);
  await enc("mnemonic", new TextEncoder().encode(mnemonic));
}

export async function loadLocalKeys({ userId, password, salt }) {

	// Derive a symmetric encryption key using the password + salt via PBKDF2
	const key = await deriveKeyFromPassword(password, salt);

	const dec = async (label) => {
    const raw = localStorage.getItem(`unlink_${userId}_${label}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const decrypted = await decryptData(parsed, key);
    return Uint8Array.from(JSON.parse(decrypted));
 	};

	const mnemonicRaw = localStorage.getItem(`unlink_${userId}_mnemonic`);
	const mnemonic = mnemonicRaw
	? new TextDecoder().decode(
    	Uint8Array.from(JSON.parse(await decryptData(JSON.parse(mnemonicRaw), key)))
  	)
  : null;

  const fundingPrivateKey = await dec("funding_private");
  const fundingPublicKey = await dec("funding_public");

  let fundingSecretKey;
  if (fundingPrivateKey && fundingPublicKey) {
  	const { secretKey } = nacl.sign.keyPair.fromSeed(fundingPrivateKey);
  	fundingSecretKey = secretKey;
  }

	return {
		kyberPrivateKey: await dec("kyber_private"),
		kyberPublicKey: await dec("kyber_public"),
		viewPrivateKey: await dec("view_private"),
		viewPublicKey: await dec("view_public"),
		fundingPrivateKey,
		fundingPublicKey,
		fundingKeypair: fundingSecretKey? Keypair.fromSecretKey(fundingSecretKey): undefined,
		mnemonic,
	};
}